/* eslint-disable */
import Vue from 'vue'
import { ToastPlugin, ModalPlugin, VBTooltip, VBPopover } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from '@/router'
import store from '@/store'
import App from '@/App.vue'

// 3rd party plugins
import '@/plugins/axios'
import '@/plugins/portal-vue'
import '@/plugins/toastification'
import '@/plugins/vue-select'
import '@/plugins/vee-validate'
import '@/plugins/feather-icon'
import '@/plugins/acl'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.directive('b-tooltip', VBTooltip)
Vue.directive('b-popover', VBPopover)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
